import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import screenName from 'Utils/screenName';

export default function useScreenName() {
  const location = useLocation();

  // Clean the last "/" to match URLS_REMAP in screenName
  const cleanPath = location.pathname.endsWith('/') ? location.pathname.slice(0, -1) : location.pathname;

  return useMemo(() => screenName(cleanPath), [cleanPath]);
}
